<template>
  <div
    v-if="isPaymentRequired"
    :class="[isPaymentModal && 'flex flex-col items-end']"
  >
    <span
      :class="[isFooter && 'text-2xl', isPaymentModal && 'font-semibold']"
      class="font-medium"
    >
      ${{ amount }}
    </span>
    <span
      class="text-[10px] text-cool-gray-50 -ml-1"
      :class="[isPaymentModal && '!text-xs']"
    >
      <span v-if="!isPaymentModal">/</span>
      <span
        v-else
        class="mr-1"
      >per</span>{{ paymentPeriod }}
    </span>
  </div>
  <div
    v-else
    :class="[isFooter && 'uppercase']"
    class="font-medium text-cool-gray-100"
  >
    {{ $t('mycountly.dashboard.deployments.free') }}
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useDeploymentStore } from '@/stores/deployment';

export default {
  props: {
    amount: {
      type: String,
      default: '0',
    },
    isFooter: {
      type: Boolean,
      default: false,
    },
    isPaymentModal: {
      type: Boolean,
      default: false,
    },
    paymentPeriod: {
      type: String,
      default: 'month',
    },
  },
  computed: {
    isPaymentRequired() {
      return this.amount !== '0';
    },
  },
};
</script>
